import Vue from 'vue';
import store from 'src/store';
export default Vue.extend({
    props: {
        sessionContext: {
            type: Object
        },
        modeParams: {
            type: Object
        }
    },
    watch: {
        sessionContext: {
            immediate: true,
            deep: true,
            handler(val) {
                if (val === null || val === void 0 ? void 0 : val.appId)
                    store.dispatch('authorizedUser/setCurrentAppObjectById', val.appId);
            }
        },
        modeParams: {
            immediate: true,
            deep: true,
            handler(newVal, oldVal) {
                store.dispatch('mode/setCurrentMode', Object.assign(Object.assign(Object.assign({}, oldVal), newVal), { preserveDisplayedUrl: true }));
            }
        }
    }
});
